import { StaticResourceMapper } from 'mapper/StaticResourceMapper';

export const staticResourceMapper = new StaticResourceMapper();
